export interface PasswordComplexity {
  min: number;
  max: number;
}

export const passwordComplexity: PasswordComplexity = {
  min: 8,
  max: 64,
};
